import * as Mui from "@mui/material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import FormInput from "../common/FormInput";
import { VehicleInspection } from "./Types";
import * as MuiIcons from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { nameof } from "../common/ObjectUtils";
import { useContext, useEffect, useState } from "react";
import VehicleInspectionService from "./sevices/VehicleInspection.action";
import useSnackbar from "../../hooks/useSnackbar";
import { ContextOperation } from "../../context/OperationContext";
import * as Yup from "yup";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { DateTimePicker } from "@mui/x-date-pickers";
interface Props{
    open: boolean;
    onClose: () => void;
    id:number;
    vehicleId:number;
    setRefresh:any;
    pageState:any;
    VehicleSelected:any
}
const EditVehcleInspection =(props:any) =>{
    const {setLoading} = useContext(ContextOperation);
    const snackbar = useSnackbar();
    const t = useOperationTranslation();
    const {tenant} = useContext(ContextOperation);
    var reg = /^[0-9\b]+$/;
    let dataFormSearchEdit = props.VehicleSelected;
   
 let validateForm = {
  kmInspection: Yup.number()
    .required(t("vehicleInspection.crate.validationForm.kmInspectionRequired"))
    .typeError(t("vehicleInspection.validateForm.kmTypeError")),
    inspectionDate: Yup.date()
    .required(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
    .typeError(t("vehicleInspection.crate.validationForm.inspectionDateRequired")),
};


if (props.pageState.length > 1) {
  validateForm = {
    kmInspection: Yup.number()
      .required(t("vehicleInspection.crate.validationForm.kmInspectionRequired"))
      .typeError(t("vehicleInspection.validateForm.kmTypeError"))
      .min(
        props.pageState[1].kmInspection + 1,
        t("vehicleInspection.crate.validationForm.kmInspectionError")
      ),

      inspectionDate: Yup.date()
      .required(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
      .typeError(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
      .test(
        "DOB",
        t("vehicleInspection.validateForm.greaterDate"),
        (inspectionDate) => {
          return (
            dayjs(props.pageState[1].inspectionDate).diff(dayjs(inspectionDate)) <
            0
          );
        }
      ),
  };
}

// if (props.pageState.length > 1) {
//   validateForm = {
//     kmInspection: Yup.number()
//       .required(t("vehicleInspection.crate.validationForm.kmInspectionRequired"))
//       .typeError(t("carMaintenance.createAndEdit.validateForm.kmTypeError"))
//       .min(
//         props.pageState[0].kmInspection + 1,
//         t("vehicleInspection.crate.validationForm.kmInspectionError")
//       ),

//       inspectionDate: Yup.date()
//       .required(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
//       .typeError(t("vehicleInspection.crate.validationForm.inspectionDateRequired"))
//       .test(
//         "DOB",
//         t("carMaintenance.createAndEdit.validateForm.greaterDate"),
//         (inspectionDate) => {
//           return (
//             dayjs(props.pageState[0].inspectionDate).diff(dayjs(inspectionDate)) <
//             0
//           );
//         }
//       ),
//   };
// }

const ValidateForm = Yup.object().shape(validateForm);
const formik = useFormik({
  initialValues: {
    inspectionDate:`${dataFormSearchEdit?.kmInspection}`,
    kmInspection: `${dataFormSearchEdit?.inspectionDate}`
  },
  validationSchema: ValidateForm,
  onSubmit: (values) => {
    editVehicle(values);
  },
});
useEffect(()=>{
  formik.setValues({
    kmInspection:`${dataFormSearchEdit?.kmInspection}`,
    inspectionDate: `${dataFormSearchEdit?.inspectionDate}`,

  })
},[props.open])

 const editVehicle =(values:any)=>{
    setLoading(true);
      VehicleInspectionService.update.updateVehicle(tenant,props.id,values).then(response=>{
        props.onClose()
       setLoading(false);
    snackbar.show("success",t("vehicleInspection.edit.successMessage"));
    props.setRefresh();
   },(error:any)=>{
       props.onClose();
       setLoading(false);
       if (error.response.status == 409) {
           snackbar.show("error", t("vehicleInspection.edit.edit409Error"));
         
         }
   })
    // }
    setLoading(false);
 }


 return (
  <Mui.Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
           <form id="submit1"  onSubmit={formik.handleSubmit}>
     <Mui.DialogTitle>
       <Mui.Grid container alignItems="center">
         <Mui.Grid item xs="auto">
           <Mui.Typography variant="h6">
             {t("vehicleInspection.edit.title")}
           </Mui.Typography>
         </Mui.Grid>
         <Mui.Grid item xs="auto" marginLeft="auto">
           <Mui.IconButton onClick={props.onClose}>
             <MuiIcons.Close />
           </Mui.IconButton>
         </Mui.Grid>
       </Mui.Grid>
     </Mui.DialogTitle>
     <Mui.DialogContent>
      
         <Mui.Grid container spacing="16px" p={2}>
           <Mui.Grid xs item>
           <DateTimePicker
                      onChange={(e: any) => {
                        formik.setFieldValue(
                          "inspectionDate",
                          dayjs.utc(e).format("YYYY-MM-DDTHH:mm:ssZ")
                        );
                      }}
                      mask={"__/__/____ __:__"}
                      inputFormat={"DD/MM/YYYY HH:mm"}
                      disableFuture
                      label={t("vehicleInspection.crate.inspectionDate")}
                      ampm={false}
                      value={formik.values.inspectionDate}
                      renderInput={(params) => (
                        <>
                          <Mui.TextField
                            variant="standard"
                           
                            fullWidth
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                             // placeholder: t("carMaintenance.createAndEdit.dateInput"),
                            }}
                            name="inspectionDate"
                            onBlur={formik.handleBlur}
                            error={
                              (formik.touched.inspectionDate && Boolean(formik.errors.inspectionDate))
                            }
                            helperText = {(formik.touched?.inspectionDate && formik.errors?.inspectionDate )
                            }
                          />
                        </>
                      )}
                    />
           </Mui.Grid>

           <Mui.Grid xs item>
             <Mui.Box>
             <Mui.TextField
                    fullWidth
                    id="kmInspection"
                    name="kmInspection"
                    type="text"
                    label={t("vehicleInspection.crate.kmInspection")}
                    value={formik.values.kmInspection}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.kmInspection && Boolean(formik.errors.kmInspection) 
                    }
                    helperText = {(formik.touched?.kmInspection && formik.errors?.kmInspection )}
                  />
             </Mui.Box>
           </Mui.Grid>
         </Mui.Grid>
      
     </Mui.DialogContent>
     <Mui.DialogActions>
       <Mui.Grid container justifyContent="end" spacing="16px" p={2}>
         <Mui.Grid item xs="auto">
           <Mui.Button variant="outlined" size="medium" onClick={props.onClose}>
             {t(
               "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
             )}
           </Mui.Button>
         </Mui.Grid>
         <Mui.Grid item xs="auto">
           <Mui.Button type="submit" size="medium">
             {t("actionButtons.save")}
           </Mui.Button>
         </Mui.Grid>
       </Mui.Grid>
     </Mui.DialogActions>
     </form>
           </Mui.Dialog>
 );
}
export default EditVehcleInspection;


